import { ReactElement } from 'react';
import { Box } from '../box';
import { Text } from '../text';

type InfoCardProps = {
  title: string;
  children: ReactElement | string;
};

const InfoCard = (props: InfoCardProps) => {
  return (
    <Box
      borderTopLeftRadius={2}
      borderTopRightRadius={2}
      border={'1px solid #ebebf5'}
      boxShadow={
        'rgba(40, 36, 229, 0.05) -2px -2px 6px, rgba(40, 36, 229, 0.05) 2px 2px 6px'
      }
    >
      <Text
        as="h2"
        backgroundColor={'neutral100'}
        color={'neutral700'}
        borderTopLeftRadius={'4px'}
        borderTopRightRadius={'4px'}
        height={'28px'}
        fontSize={1}
        py={2}
        pl={5}
        fontWeight={500}
      >
        {props.title}
      </Text>
      <Box p={5}>{props.children}</Box>
    </Box>
  );
};

export { InfoCard };
